{
  "data_driven": {
    "formula_applied": "Fórmula aplicada",
    "by_attributes": "Por atributos",
    "any_others": "Quaisquer outros"
  },
  "styles2": {
    "bold": "Ousado",
    "regular": "Normal",
    "on": "Ligado",
    "off": "Desligado",
    "arrow_spacing": "Espaçamento entre setas",
    "arrow_colour": "Cor da seta",
    "arrow_size": "Tamanho da seta",
    "arrow_opacity": "Opacidade da seta",
    "rotation": "Rotação",
    "rotate_icon": "Ícone de rotação",
    "orientation_3d": "Orientação 3D",
    "flat": "Plano",
    "raised": "Levantado",
    "degrees": "Diplomas",
    "model": "modelo",
    "type": "Tipo",
    "scale": "Escala",
    "choose_model": "Escolha o modelo",
    "error_loading_models": "Houve um erro ao carregar os modelos 3D",
    "solid": "Sólido",
    "dashed": "Tracejado",
    "type_of_line": "Tipo de linha",
    "Line": "Linha",
    "Area": "Área",
    "Point": "Ponto",
    "Icon": "Ícone",
    "Model": "modelo",
    "LineModel": "Linha de modelos 3D",
    "AreaModel": "Área de modelos 3D",
    "spacing": "Espaçamento",
    "plural": {
      "Icon": "Ícones",
      "Point": "Pontos"
    }
  },
  "object": {
    "deleteTitle": "Excluir objeto (s) selecionado (s)",
    "deleteDescription": "Tem certeza de que deseja excluir o (s) objeto (s) selecionado (s)?",
    "deleteToast": "{{ count }} objetos excluídos",
    "multiple": "Múltiplo",
    "multiple_objects": "Vários objetos"
  },
  "controls": {
    "draw": "Desenhar",
    "copy": "Copiar",
    "select": "Selecionar (camadas ativas)",
    "area_select": "Selecionar (Todas as camadas)",
    "area_select_invalid": "A área sorteada precisa ter 3 ou mais pontos para ser válida",
    "analysis": "Análise",
    "search": "Pesquisar",
    "grab": "Agarre",
    "toggle_3d_terrain": "Terreno 3D",
    "toggle_globe": "Visão do globo",
    "toggle_3d_buildings": "Edifícios 3D",
    "zoom_in": "Ampliar",
    "zoom_out": "Diminua o zoom",
    "reset": "Redefinir visualização",
    "vr": "Gêmeo digital",
    "comments": "Comentários",
    "calendar": "Calendário",
    "zoom_to_all_objects": "Amplie todos os objetos",
    "no_objects_to_zoom": "Nenhum objeto visível no plano",
    "bookmarks": "Favoritos"
  },
  "analysis": {
    "analysis_title": "Ferramentas de análise",
    "distance_title": "Distância",
    "distance_description": "Meça a distância ao longo de uma linha",
    "distance_content": {
      "title": "Distância total da linha de referência no mapa"
    },
    "walk_time_title": "Tempo de caminhada",
    "walk_time_description": "Calcular o tempo de caminhada ao longo de uma linha",
    "walk_time_content": {
      "title": "Tempo total de viagem ao caminhar",
      "approx_time": "Aprox. {{ speed }} minutos em",
      "m_per_second": "m/segundo"
    },
    "flow_rate_title": "Taxa de fluxo",
    "flow_rate_description": "Fluxo calculado de pessoas através de um portão (linha desenhada no mapa)",
    "flow_rate_content": {
      "total_width": "Largura total do portão (comprimento da linha)",
      "per_minute_per_hour": "{{ perMinute }} por {{ perHour }} por hora",
      "at": "em",
      "people_meter_minute": "pessoas/metro/ minuto",
      "fruin_service_levels": "Reduza os níveis de serviço"
    },
    "area_title": "Área",
    "area_description": "Meça a área dentro de uma forma no mapa",
    "area_content": {
      "title": "Área total do polígono de referência no mapa"
    },
    "capacity_content": {
      "total_area": "Área total",
      "per_m_sq": "{{ perMSq }} por m²",
      "at": "em",
      "people_meter_sq": "m²/ pessoa",
      "people_ft_sq": "pés² /pessoa",
      "fruin_service_levels": "Reduza os níveis de serviço"
    },
    "capacity_title": "Capacidade",
    "capacity_description": "Calcular a capacidade de retenção (pessoas) de uma área no mapa",
    "count_title": "Conde",
    "count_description": "Conte os objetos dentro de uma área no mapa",
    "count_content": {
      "total": "Total",
      "current_level": "Nível atual",
      "all_levels": "Todos os níveis"
    }
  },
  "styles": {
    "line_fill": "Preenchimento de linha",
    "colour": "Cor",
    "colours": "Cores",
    "opacity": "Opacidade",
    "blur": "Desfoque",
    "measurement": "Medição",
    "width": "Largura",
    "offset": "Compensação",
    "join_and_end": "Termina e une",
    "join": "Junta-se",
    "end": "Termina",
    "arrows": "Flechas",
    "line_terminator_icon": "Ícone (s) de fim de linha",
    "line_terminator_icon_start": "Iniciar",
    "line_terminator_icon_end": "Fim",
    "line_terminator_icon_both": "Ambos",
    "text": "Texto",
    "text_colour": "Cor do texto",
    "text_font": "Fonte do texto",
    "text_weight": "Peso do texto",
    "text_size": "Tamanho do texto",
    "text_overlap": "Sobreposição de texto",
    "allow_text_overlap": "Mostrar tudo",
    "no_text_overlap": "Combinar",
    "text_outline_width": "Largura do contorno do texto",
    "text_outline_colour": "Cor do contorno do texto",
    "text_opacity": "Opacidade do texto",
    "text_content": "Conteúdo de texto",
    "outline": "Esboço",
    "outline_type": "Tipo de esboço",
    "outline_colour": "Cor do contorno",
    "outline_opacity": "Opacidade do contorno",
    "outline_width": "Largura do contorno",
    "outline_blur": "Desfoque do contorno",
    "no_colour": "Sem cor",
    "company_palette": "Paleta da empresa",
    "type_of_area": "Tipo de área",
    "area_2d": "Área 2D",
    "area_3d": "Área 3D",
    "height": "Altura",
    "type_of_point": "Tipo de ponto",
    "point_fill": "Preenchimento de pontos",
    "radius": "Raio",
    "pitch_alignment": "Orientação 3D",
    "area_fill": "Preenchimento de área",
    "placement": "Posicionamento",
    "pitch_alignment_map": "Plano",
    "pitch_alignment_viewport": "Levantado",
    "pitch_alignment_map_desc": "{{ styleType }} deite-se de forma plana no plano do mapa",
    "pitch_alignment_viewport_desc": "{{ styleType }} sempre estará de frente para a câmera",
    "icon": "Ícone",
    "icon_image": "Imagem do ícone",
    "icon_size": "Tamanho",
    "icon_colour": "Cor",
    "icon_opacity": "Opacidade",
    "rotation": "Rotação",
    "allow_overlap": "Sobreposição de ícones",
    "show_all": "Mostrar tudo",
    "combine": "Combinar",
    "choose_icon_image": "Escolha a imagem do ícone",
    "open_icon_selector": "Abrir seletor de ícones",
    "spacing": "Espaçamento",
    "model_offset": "Offset do modelo",
    "line_model_line_colour": "Cor da linha",
    "line_model_line_width": "Largura da linha",
    "type": "Tipo de linha",
    "line_model_line_type": "Tipo de linha"
  }
}